import { HorizontalLine } from "../horizontal-line/horizontal-line";
import { FaBath, FaWifi, FaTv } from "react-icons/fa";
import {
  MdOutlineBed,
  MdOutlineBalcony,
  MdOutlineKitchen,
} from "react-icons/md";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { TbAirConditioning } from "react-icons/tb";

import { Swiper, SwiperSlide } from "swiper/react";
import { register } from "swiper/element/bundle";
import { Pagination, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./rooms.css";

import room202 from "../../assets/room202.jpg";
import room306 from "../../assets/room306.jpg";
import room206 from "../../assets/room206.jpg";
import room101 from "../../assets/room101.jpg";

register();

export const Rooms = () => {
  const roomsOverview = [
    {
      roomType: "Standard Room",
      image: room202,
      description:
        "This room is one of our best selling room. This is the most budget friendly room that we have.",
      isDeluxe: false,
      isSuite: false,
      isTwin: false,
    },
    {
      roomType: "Deluxe Room",
      image: room306,
      description:
        "This room has all the facilities that a Standard Room offers plus a air conditioning.",
      isDeluxe: true,
      isSuite: false,
      isTwin: false,
    },
    {
      roomType: "Suite Room",
      image: room206,
      description:
        "This room has all the facilities that a Deluxe Room offers plus a private balcony and a Kitchen.",
      isDeluxe: true,
      isSuite: true,
      isTwin: false,
    },
    {
      roomType: "Twin Room",
      image: room101,
      description:
        "This room has all the facilities that Standard Room offers, but has only one master bed, and a private balcony",
      isDeluxe: false,
      isSuite: false,
      isTwin: true,
    },
  ];
  return (
    <div className="py-[40px] bg-grayish-white pb-[100px]">
      <div className="relative">
        <div className="pt-[35px] px-[15px]">
          <div className="room-wrapper ">
            <h3 className="text-center text-[28px] mb-[25px] font-[400] md:mt-[50px]">
              Our Rooms
            </h3>
            <div className="my-[28px] z-[1]">
              <HorizontalLine width={50} />
            </div>
            <div className="max-w-[650px] w-[calc(100%_-_60px)] mx-auto ">
              <p className="text-center leading-[180%] mb-[30px] md:mb-[50px] text-[15px] text-gray-text">
                We have in total 21 rooms and 4 room categories. Standard, Twin,
                Deluxe and Suite Room. There are 9 Standard Rooms, 6 Deluxe
                Rooms, 3 Twin Rooms and 3 Suite Rooms.
              </p>
            </div>
            {/* swiper starts from here */}
            <Swiper
              autoplay={false}
              grabCursor={true}
              spaceBetween={50}
              centeredSlides={true}
              centeredSlidesBounds={true}
              loop={false}
              slidesPerView={"auto"}
              pagination={{ el: ".swiper-pagination", clickable: true }}
              navigation={{
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                clickable: true,
              }}
              modules={[Pagination, Navigation]}
              className="swiper_container rooms_swiper"
            >
              {roomsOverview.map((room) => {
                return (
                  <SwiperSlide>
                    <div className="room-cards-container w-[calc(100%)] h-[600px] md:h-[580px] rounded-2xl bg-white">
                      <div className="h-52 w-full rounded-2xl p-4">
                        <img
                          src={room.image}
                          alt="Standard Room"
                          className="h-full w-full rounded-2xl"
                        />
                        <div className="mt-4">
                          <h2
                            className="font-bold text-[20px] md:text-lg text-black line-clamp-1"
                            title="New York"
                          >
                            {room.roomType}
                          </h2>
                          <p
                            className="mt-2 text-sm text-gray-text mr-[20px]"
                            title="New York, NY 10004, United States"
                          >
                            {room.description}
                          </p>
                        </div>

                        <div className="grid grid-cols-2 grid-rows-2 gap-4 mt-8">
                          <p className="flex-col xl:flex-row xl:items-center text-gray-800">
                            <MdOutlineBed className="text-[25px] text-golden"></MdOutlineBed>
                            {room.isTwin ? (
                              <span className="mt-2 xl:mt-0">2 pax</span>
                            ) : (
                              <span className="mt-2 xl:mt-0">2 + 1 pax</span>
                            )}
                          </p>
                          {room.isDeluxe ? (
                            <p className="flex-col xl:flex-row xl:items-center text-gray-800">
                              <TbAirConditioning className="text-[25px] text-golden"></TbAirConditioning>
                              <span className="mt-2 xl:mt-0">
                                Air Conditioning
                              </span>
                            </p>
                          ) : (
                            <p className="flex-col xl:flex-row xl:items-center text-gray-800">
                              <FaBath className="text-[20px] text-golden"></FaBath>
                              <span className="mt-2 xl:mt-0">Hot / Cold</span>
                            </p>
                          )}
                          {room.isSuite || room.isTwin ? (
                            <p className="flex-col xl:flex-row xl:items-center text-gray-800">
                              <MdOutlineBalcony className="text-[20px] text-golden"></MdOutlineBalcony>
                              <span className="mt-2 xl:mt-0">
                                Private Balcony
                              </span>
                            </p>
                          ) : (
                            <p className="flex-col xl:flex-row xl:items-center text-gray-800">
                              <FaTv className="text-[20px] text-golden"></FaTv>
                              <span className="mt-2 xl:mt-0">Television</span>
                            </p>
                          )}

                          {room.isSuite ? (
                            <p className="flex-col xl:flex-row xl:items-center text-gray-800">
                              <MdOutlineKitchen className="text-[20px] text-golden"></MdOutlineKitchen>
                              <span className="mt-2 xl:mt-0">
                                Private Kitchen
                              </span>
                            </p>
                          ) : (
                            <p className="flex-col xl:flex-row xl:items-center text-gray-800">
                              <FaWifi className="text-[20px] text-golden"></FaWifi>
                              <span className="mt-2 xl:mt-0">Free Wifi</span>
                            </p>
                          )}
                        </div>

                        <button
                          id="booknow-btn"
                          className="bg-golden w-full h-[50px] text-white font-bold mt-[40px]"
                          onClick={() => {
                            const [first, second] = room.roomType.split(" ");
                            const formattedType = `${first}+${second}`;
                            const url = `https://docs.google.com/forms/d/e/1FAIpQLSeODAN5kmIEDo-z5xZgfYnk_GD5nnGwqcauKe042J1jygasqg/viewform?usp=pp_url&entry.361077647=${formattedType}`;
                            window.open(url, "_blank");
                          }}
                        >
                          <p className="">Book This</p>
                        </button>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
              <div className="slider-controler ">
                <div className="slider-arrow swiper-button-prev">
                  <BsChevronLeft className="text-golden stroke-2"></BsChevronLeft>
                </div>
                <div className="slider-arrow swiper-button-next">
                  <BsChevronRight className="text-golden stroke-2"></BsChevronRight>
                </div>
                <div className="swiper-pagination"></div>
              </div>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};
